export default __webpack_public_path__ + "59daf17080de005671e8c071fdc58e93.svg";